import React from 'react';
import { Col, Row, Button, Modal } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { images } from '@assets/img';
import ImageComponent from '@sharedComponent/image-component';
import './bank.scss';
export const getMaskAccountNumber = (accountNumber) => {
	if (!accountNumber) {
		return;
	}
	return accountNumber
		.replace(/\s/g, '')
		.replace(/\d(?=\d{4})/g, 'X')
		.replace(/(.{4})/g, '$1 ');
};

export const BankAccountCard = ({ bankInfo, state, handleChange, activateBank, deleteBank }) => {
	const [states, setState] = useState(false);
	const [isMaskAccount, setIsMaskAccount] = useState(true);
	const [isMaskRouting, setIsMaskRouting] = useState(true);
	return (
		<Col className="bank_card">
			<Row>
				<Col xl={21} lg={21} md={21} sm={21} xs={21}>
					<Row className="inactive_cards">
						<Col xl={24} lg={24} md={24} sm={24} xs={24}>
							<Row className="card_head" onClick={() => setState(!states)}>
								<Col xl={12} lg={12} md={12} sm={12} xs={12} className="bank_name">
									{' '}
									{bankInfo.bankName}
								</Col>
								<Col xl={12} lg={12} md={12} sm={12} xs={12} className="bank_account_number">
									{isMaskAccount ? getMaskAccountNumber(bankInfo.accountNumber) : bankInfo.accountNumber}
								</Col>
							</Row>
						</Col>
						{states ? (
							<Col xl={24} lg={24} className="card_body">
								<Row style={{ alignItems: 'center' }}>
									<Col xl={8} lg={8} md={8} sm={24} xs={24} className="content_label">
										Bank Name
									</Col>
									<Col xl={1} lg={1} md={1} sm={0} xs={0} className="content_seperate">
										:
									</Col>
									<Col xl={13} lg={13} md={13} sm={24} xs={24} className="content_value">
										{bankInfo.bankName}
									</Col>

									<Col xl={8} lg={8} md={8} sm={24} xs={24} className="content_label">
										Account Nickname
									</Col>
									<Col xl={1} lg={1} md={1} sm={0} xs={0} className="content_seperate">
										:
									</Col>
									<Col xl={13} lg={13} md={13} sm={24} xs={24} className="content_value">
										{bankInfo.accountNickName}
									</Col>

									<Col xl={8} lg={8} md={8} sm={24} xs={24} className="content_label">
										Routing Number
									</Col>
									<Col xl={1} lg={1} md={1} sm={0} xs={0} className="content_seperate">
										:
									</Col>
									<Col xl={13} lg={13} md={13} sm={24} xs={24} className="content_value">
										<Row>
											<Col xl={20} lg={20} md={20} sm={20} xs={20}>
												{isMaskRouting ? getMaskAccountNumber(bankInfo.routingNumber) : bankInfo.routingNumber}
											</Col>
											<Col xl={4} lg={4} md={4} sm={4} xs={4} onClick={() => setIsMaskRouting(!isMaskRouting)}>
												{isMaskRouting ? <EyeInvisibleOutlined /> : <EyeOutlined />}
											</Col>
										</Row>
									</Col>

									<Col xl={8} lg={8} md={8} sm={24} xs={24} className="content_label">
										Account Number
									</Col>
									<Col xl={1} lg={1} md={1} sm={0} xs={0} className="content_seperate">
										:
									</Col>
									<Col xl={13} lg={13} md={13} sm={24} xs={24} className="content_value">
										<Row>
											<Col xl={20} lg={20} md={20} sm={20} xs={20}>
												{isMaskAccount ? getMaskAccountNumber(bankInfo.accountNumber) : bankInfo.accountNumber}
											</Col>
											<Col xl={4} lg={4} md={4} sm={4} xs={4} onClick={() => setIsMaskAccount(!isMaskAccount)}>
												{isMaskAccount ? <EyeInvisibleOutlined /> : <EyeOutlined />}
											</Col>
										</Row>
									</Col>

									<Col xl={8} lg={8} md={8} sm={24} xs={24} className="content_label">
										Account Type
									</Col>
									<Col xl={1} lg={1} md={1} sm={0} xs={0}>
										:
									</Col>
									<Col xl={13} lg={13} md={13} sm={24} xs={24} className="content_value">
										{bankInfo.accountType}
									</Col>
									<Col xl={16} lg={16} md={24} sm={24} xs={24}>
										<Button
											className="activate_btn"
											onClick={() => {
												activateBank(bankInfo.accountId);
											}}>
											Activate
										</Button>
									</Col>
								</Row>
							</Col>
						) : null}
					</Row>
				</Col>
				<Col xl={1} lg={1} md={1} sm={1} xs={1}></Col>
				<Col xl={2} lg={2} md={2} sm={2} xs={2}>
					<Col
						className="delete_area"
						onClick={() => {
							handleChange('activeDeleteModal', true);
						}}>
						<DeleteOutlined />
					</Col>
				</Col>
			</Row>
			{/* Modal : delete inactive accounts */}
			<Modal
				visible={state.activeDeleteModal}
				title={null}
				centered={true}
				footer={null}
				closable={false}
				style={{ minWidth: '50%' }}
				onCancel={() => handleChange('activeDeleteModal', false)}
				destroyOnClose={true}
				className="inactive_delete_modal">
				<Col className="inactive_delete_modal_header">Your are about to delete this bank account, do you want to delete?</Col>
				<Col style={{ textAlign: 'center', marginTop: '20px' }}>
					<ImageComponent src={images.deleteimg} />
				</Col>
				<Col className="inactive_delete_modal_content">
					You are about to delete your account. Once your account has been deleted, all data will be removed. Please confirm that you want
					to delete your account
				</Col>
				<Col>
					<Row style={{ padding: 10 }}>
						<Col xl={11} lg={11} md={24} sm={24} xs={24} style={{ marginTop: '5px' }}>
							<Button onClick={() => handleChange('activeDeleteModal', false)} className="delete_no_btn">
								No
							</Button>
						</Col>
						<Col xl={2} lg={2} md={24} sm={24} xs={24}></Col>
						<Col xl={11} lg={11} md={24} sm={24} xs={24} style={{ marginTop: '5px' }}>
							<Button className="inactive_delete_btn" onClick={() => deleteBank(bankInfo.accountId)}>
								Yes, Delete Account
							</Button>
						</Col>
					</Row>
				</Col>
			</Modal>
		</Col>
	);
};
